import { toast } from "react-toastify";
import { codeReview } from "ServerAPI/serverAPI";
export const handleCodeReview = async (payload) => {
  try {
    // Call codeReview API → now returns raw ArrayBuffer (PDF binary)
    const pdfData = await codeReview(payload);

    // Validate response
    if (!pdfData || !(pdfData instanceof ArrayBuffer)) {
      throw new Error("Invalid PDF data in response");
    }

    // Create Blob directly from ArrayBuffer
    const blob = new Blob([pdfData], { type: "application/pdf" });

    // Create object URL for Blob
    const url = window.URL.createObjectURL(blob);

    // Trigger download
    const a = document.createElement("a");
    a.href = url;
    a.download = `Code_Review_${new Date().toISOString().split("T")[0]}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Clean up
    window.URL.revokeObjectURL(url);

    // console.log("Download initiated for Code_Review PDF");
  } catch (err) {
    // console.error("Error in handleCodeReview:", err);
    toast.error("Failed to generate code review PDF");
    throw new Error(`Failed to generate code review PDF: ${err.message}`);
  }
};
